import React from 'react';
import { FormattedText, formatText } from 'core/i18n';
import { ModalComponent } from 'components/modal/modalComponent';
import './DocumentRetryRequestModal.scss';

const documentRetryRequestModal = ({ onClose, modalIsOpen }) => {
    const handleClose = () => {
        onClose('cerrar');
    };

    const handleOK = () => {
        onClose('entendido');
    };

    return (
        <ModalComponent
            isOpen={modalIsOpen}
            confirmText={formatText('button-understood')}
            onCancel={handleClose}
            onConfirm={handleOK}
            className="document-retry-request"
        >
            <div className="document-retry-request__container">
                <div className="document-retry-request__icon">
                    <span className="icons icons--icon-document-type-4" />
                </div>
                <div className="document-retry-request__title">
                    <FormattedText value="documentRetryRequest-title" />
                </div>
                <div className="document-retry-request__text">
                    <FormattedText value="documentRetryRequest-checkRejectionReasons" />
                </div>
            </div>
        </ModalComponent>
    );
};

export default documentRetryRequestModal;
